import React from 'react'
import formStyles from '../../../styles/forms.module.scss'

// A tournament carousel has no configuration. The title is authored in the
// WidgetForm header (widgetTypeHasFormTitle), and ACE applies one constant
// rule: an edition running in the seven days that start on the current day,
// with `is_licensed` set on one season or more of it (the Licensed checkbox on
// TournamentDetail), on any tour but UTR. That is the tournaments page with no
// filter applied, so Challengers and 125s are in.
// Spec: docs/html/tennischannel/widgets/tournament-carousel.html
const TournamentCarouselEditor: React.FC = () => (
  <p className={formStyles.hint}>
    A tournament appears when it plays in the next seven days and at least one of its
    seasons has <strong>Licensed</strong> checked on its tournament page. Every tour but
    UTR qualifies.
  </p>
)

export default TournamentCarouselEditor
